'use client';

import { useLayoutEffect, useRef, useState } from 'react';

import { cn } from '../../libs/utils';

import { BaseTopNavigationProps } from './type/BaseTopNavigationType';

export function BaseTopNavigation({ leftAction, rightAction, className, title, bg = false, bgColor, titleAction, ...props }: BaseTopNavigationProps) {
  const leftActionRef = useRef<HTMLDivElement>(null);
  const rightActionRef = useRef<HTMLDivElement>(null);
  const [actionWidth, setActionWidth] = useState<number | null>(null);

  useLayoutEffect(() => {
    if (!title) return;
    const leftEl = leftActionRef.current;
    const rightEl = rightActionRef.current;
    if (!leftEl || !rightEl) return;

    const leftWidth = leftEl.getBoundingClientRect().width;
    const rightWidth = rightEl.getBoundingClientRect().width;
    setActionWidth(Math.max(leftWidth, rightWidth));
  }, []);

  const sideStyle = actionWidth !== null ? { width: actionWidth } : undefined;

  return (
    <div
      className={cn(
        'z-top-navigation flex h-top-navigation items-center justify-center w-full',
        {
          'bg-neutral-background-main': bg
        },
        className
      )}
      style={{ backgroundColor: bgColor ? bgColor : '' }}
      {...props}
    >
      <div className={cn('container-padding-small container-xlarge flex items-center w-full min-w-0', { 'justify-between': !title })}>
        <div ref={leftActionRef} className="flex shrink-0 justify-start" style={sideStyle}>
          {leftAction}
        </div>
        {title && (
          <div data-testid="topNavigationTitle" className="flex min-w-0 flex-1 justify-center" onClick={() => titleAction?.()}>
            <div className={cn('body-large-semibold max-w-full truncate text-neutral-foreground-main', { 'cursor-pointer': titleAction })}>{title}</div>
          </div>
        )}
        <div ref={rightActionRef} className="flex shrink-0 justify-end" style={sideStyle}>
          {rightAction}
        </div>
      </div>
    </div>
  );
}
